/* global hUrl */

if (document.getElementsByClassName('js-api')[0]) {
  api()
}

function api() {
  const url = hUrl + 'api/'

  window.addEventListener('click', function (e) {
    const item = e.target.closest('.js-api')
    if (!item) {
      return
    }
    let param = item.dataset.param
    let flag = ''
    if (~param.indexOf('type=fav&')) {
      flag = 'fav'
    } else if (~param.indexOf('type=entry_edit&')) {
      flag = 'entry'
    }
    const id = item.dataset.id

    if (flag === 'fav') {
      // activeの有無で追加削除を決める
      if (!item.classList.contains('active')) {
        param += '&action=add'
      } else {
        param += '&action=remove'
      }
    }

    applyAjax(url, param, item, id, flag)
  })

  /*
     ###          ##    ###    ##     ##
   ##   ##        ##  ##   ##    ## ##
  ##     ##       ## ##     ##    ###
  ######### ##    ## #########   ## ##
  ##     ##  ######  ##     ## ##     ##
  */
  let ajax = false // Ajaxリクエスト

  /**
   * Ajax処理を実行する
   * @param url {string} 取得先のURL
   * @param from {string} 書き換え元のセレクタ　,区切りで複数指定
   * @param to {string} 取得先のセレクタ　,区切りで複数指定
   * @param pushSt {string|boolean} 擬似的にページ遷移する　falseじゃなければ有効
   * @param type {string} rep:要素を書き換える add:書き換え元の下に追加する
   * @param scroll {string} 指定の位置にスクロールさせる
   * @param flag {string} 独自の拡張用
   */
  function applyAjax(url, param, item, id, flag) {
    const errorText = 'エラーが発生しました。時間をおいて再度お試しください'
    // if (ajax) {
    //   // 既に通信中なら切断
    //   ajax.abort()
    // }

    ajax = new XMLHttpRequest() // Ajaxリクエスト

    const btnList = document.getElementsByClassName('js-api--' + id)
    for (const iterator of btnList) {
      iterator.classList.add('loading')
    }

    if (param) {
      url += (~url.indexOf('?') ? '&' : '?') + param // パラメータをURLに結合
    }

    // Ajaxと明示するパラメータを付ける
    url += (~url.indexOf('?') ? '&' : '?') + 'ajax=1'
    ajax.open('get', url, true) // GET/POST, URL, 非同期処理

    ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest') // Ajaxでのアクセスと明示するリクエストヘッダー
    // キャッシュせず最新のデータを取る場合のリクエストヘッダー3種
    // ajax.setRequestHeader('Pragma', 'no-cache')
    // ajax.setRequestHeader('Cache-Control', 'no-cache')
    // ajax.setRequestHeader('If-Modified-Since', 'Thu, 01 Jun 1970 00:00:00 GMT')

    ajax.responseType = 'json' // 取得タイプ document text json
    ajax.timeout = 10000 // タイムアウト判定時間

    ajax.send() // GETリクエスト実行

    ajax.onload = function () {
      // アクセス成功
      if (ajax.status < 200 || ajax.status >= 400) {
        console.log('Error: Code ' + ajax.status) // エラー
        return
      }
      if (ajax.response['message']) {
        window.popToast(ajax.response['message'])
      }
      if (flag === 'fav') {
        // お気に入りボタンをトグルする
        if (ajax.response['type'] === 'add') {
          for (const iterator of btnList) {
            iterator.classList.add('active')
          }
        } else {
          for (const iterator of btnList) {
            iterator.classList.remove('active')
          }
        }

        window.countChip('fav', ajax.response['count']) // カウントを更新する
      } else if (flag === 'entry') {
        // お気に入りボタンをトグルする
        if (ajax.response['type'] === 'add') {
          for (const iterator of btnList) {
            iterator.classList.add('active')
          }
        } else {
          for (const iterator of btnList) {
            iterator.classList.remove('active')
          }
        }
      }
    }
    ajax.ontimeout = function (e) {
      // タイムアウト
      window.popToast(errorText)
    }
    ajax.onerror = function () {
      // Ajax処理失敗
      window.popToast(errorText)
    }
    ajax.onloadend = function () {
      // 受信成否に関わらず実行
      // intObsAjax()
      // ajax = false
      for (const iterator of btnList) {
        iterator.classList.remove('loading')
      }
    }
  }
}
